import { useQuery } from "@tanstack/react-query";
import { PalletService } from "src/services/pallets";
import { queryKeys } from "src/constants";

const POLL_INTERVAL_MS = 12_000;

const useBuildingPallets = (palletService: PalletService) => {
  const {
    data: buildingPallets,
    isLoading,
    isRefetching,
    error: fetchError,
    refetch: refreshBuildingPallets
  } = useQuery({
    queryKey: queryKeys.buildingPallets(),
    queryFn: () => palletService.getBuildingPallets(),
    refetchInterval: POLL_INTERVAL_MS,
    refetchIntervalInBackground: false
  });

  return {
    buildingPallets: buildingPallets ?? [],
    isLoading,
    isRefetching,
    fetchError,
    refreshBuildingPallets
  };
};

export { useBuildingPallets };
